import styled from "styled-components"
import Button from "@irati/ui/src/Button"

const MarginRightButton = styled(Button)`
  margin-right: ${({theme}) => theme.spacing.one};
`

export default MarginRightButton
